import apiClient from '../apiClient';
import { DELETE_TOUR_GUIDE_URL } from '../apiUrl';

const deleteTourGuideApi = Id => {
  return apiClient.delete(DELETE_TOUR_GUIDE_URL(Id));
};

export default deleteTourGuideApi;
